<mat-toolbar class="primary">
    <span class="adx-address-book-icon"><i class="fa-solid fa-address-book"></i></span>
    {{'ASTIMAX.CONTACT.WIDGET.DELETE_MANUAL_CONTACT' | translate }}
    <span class="adx-toolbar-spacer"></span>
    <button mat-icon-button
            [mat-dialog-close]="false"
            aria-label="Close Button"
            matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CLOSE' | translate }}">
        <fa-icon [icon]="'xmark'"></fa-icon>
    </button>
</mat-toolbar>

<mat-dialog-content class="adx-dialog-content-wrapper">
    <p class="adx-delete-contact-context">{{'ASTIMAX.CONTACT.WIDGET.DELETE_MANUAL_CONTACT_DIALOG_1' | translate }}
        <strong>{{ data.contact.name }} [{{ ContactUtils.getDisplayPhoneNumber(data.contact) }}]</strong>
        {{'ASTIMAX.CONTACT.WIDGET.DELETE_MANUAL_CONTACT_DIALOG_2' | translate }}?
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
            mat-raised-button
            (click)="onCancel()"
            type="button"
            aria-label="Cancel deletion"
            matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}
    </button>
    <button
            mat-raised-button
            class="warn"
            type="button"
            (click)="onDelete()"
            [disabled]="!canDelete()"
            [attr.aria-label]="canDelete() ? 'Delete manual contact' : 'Cannot delete - confirmation required'"
            matTooltip="{{'ASTIMAX.CONTACT.WIDGET.DELETE_CONTACT' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.DELETE' | translate }}
    </button>
</mat-dialog-actions>
